<script lang="ts">
import { computed, defineComponent, h, unref } from 'vue';

import { hSlot, warn } from '@components/utils';

import { useRender } from '../../composable';
import { useInjectLayout } from '../CdsLayout/context';

import { useProvideMain } from './context';

import type { CSSProperties } from 'vue';

export const componentName = 'CdsMain';
export default defineComponent({
  name: componentName,
  setup(_props, { slots, expose }) {
    const layout = useInjectLayout();

    if (!Object.keys(layout).length) {
      warn('Main', 'CdsMain component must be used inside of a CdsLayout component.');
      return () => {};
    }

    useProvideMain(true);

    const style = computed(() => {
      const css: CSSProperties = {};

      if (layout.header.space) {
        css.paddingTop = layout.header.size + 'px';
      }

      if (layout.right.space) {
        css.paddingRight = layout.right.size + 'px';
      }

      if (layout.footer.space) {
        css.paddingBottom = layout.footer.size + 'px';
      }

      if (layout.left.space) {
        css.paddingLeft = layout.left.size + 'px';
      }

      return css;
    });

    expose({
      ...layout
    });

    useRender(() =>
      h(
        'main',
        {
          class: 'cds-main',
          style: unref(style)
        },
        hSlot(slots.default, [])
      )
    );

    return {};
  }
});
</script>

<style lang="scss">
@import './CdsMain';
</style>
